export default {
  wind: {
    displayName: 'Wind',
    value: 'wind'
  },
  avg: {
    displayName: 'Wind - Avg',
    value: 'avg'
  },
  gust: {
    displayName: 'Wind - Gust',
    value: 'gust'
  },
  lull: {
    displayName: 'Wind - Lull',
    value: 'lull'
  },
  direction: {
    displayName: 'Wind Direction',
    value: 'direction'
  },
  atemp: {
    displayName: 'Air Temp',
    value: 'atemp'
  },
  pres: {
    displayName: 'Pressure',
    value: 'pres'
  },
  rh: {
    displayName: 'Rel Humidity',
    value: 'rh'
  },
  wtemp: {
    displayName: 'Water Temp',
    value: 'wtemp'
  },
  waveheight: {
    displayName: 'Swell',
    value: 'waveheight'
  },
  waterlevel: {
    displayName: 'Water Level',
    value: 'waterlevel'
  },
  precip: {
    displayName: 'Precipitation',
    value: 'precip2'
  }
}